$(document).ready(function() {
  // Confirmation modal
  const urlParameters = new URLSearchParams(window.location.search);

  if (urlParameters.has('show-confirmation-modal')) {
    $.magnificPopup.open({
      items: {
        src: '#confirmation-modal',
        type: 'inline',
      },
    });

    // Remove query parameter so that modal is only shown once.
    window.history.replaceState({}, document.title, window.location.pathname);
  }

  // Variant selectors
  $('.js-line-item__variant-selector-control').on('change', function () {
    const currentProductVariantId = $(this).closest('[data-product-variant-id]').attr('data-product-variant-id');
    const currentProductQuantity = $(this).closest('[data-product-variant-id]').attr('data-quantity');
    const newProductVariantId = $(this).val();

    // Remove current product variant, then add new product variant, then refresh the page.
    $.ajax({
      type: 'post',
      url: '/cart/change.js',
      data: `quantity=0&id=${currentProductVariantId}`,
      dataType: 'json',
      success: function () {
        $.ajax({
          type: 'post',
          url: '/cart/add.js',
          data: `quantity=${currentProductQuantity}&id=${newProductVariantId}`,
          dataType: 'json',
          success: function () {
            window.location.reload();
          },
        });
      },
    });
  });

  // @CL PREIS-152 / PREIS-158 / PREIS-159 — Save handler for the free-text
  // fields in the cart recap (PO Number, Shipping instructions, Order note). A
  // single delegated listener keyed on data-action="save-cart-attribute" serves
  // every such field: the order note persists into cart.note, the others into
  // cart.attributes[Key] (the key is read from the field's name, attributes[Key]).
  // Scoping the "edit" pill lookup to the field's own .cart-recap__note container
  // is what makes the pill appear immediately on save. theme.js's original
  // CartSection._saveNote queried the whole section instead, so saving the note
  // toggled the first pill (PO Number) and the note's own pill only showed after
  // a page refresh — hence PREIS-159. Routing the note through here fixes that.
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-action="save-cart-attribute"]');
    if (!trigger) return;

    const container = trigger.closest('.cart-recap__note');
    if (!container) return;

    const field = container.querySelector('[name="note"], [name^="attributes["]');
    if (!field) return;

    const value = field.value;
    const body = field.name === 'note'
      ? { note: value }
      : { attributes: { [field.name.slice('attributes['.length, -1)]: value } };

    fetch(`${window.routes.cartUrl}/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    });

    const editPill = container.querySelector('.cart-recap__note-edit');
    if (editPill) editPill.classList.toggle('is-visible', value !== '');

    const collapsible = container.querySelector('.collapsible');
    if (collapsible) {
      document.dispatchEvent(new CustomEvent('collapsible:toggle', {
        detail: { id: collapsible.id },
      }));
    }
  });
});
